<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="add category">
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
            class="mr-n2 mt-10" style="opacity:.6;">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <form autocomplete="off" @submit.prevent="save">
          <v-row>
            <v-col cols="12" md="4">
              <label class="font-weight-medium body-2">
                Academic Year
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete clearable key="id" label="Select Academic Year" :items="academicYears"
                v-model="selectedAcademicYear" required item-text="academicYear" item-value="id"
                :hide-details="true">
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="2">
              <label class="font-weight-medium body-2">
                Type
                <span class="requir error--text">*</span>
              </label>
              <v-autocomplete clearable key="value" label="Select Type" :items="typeArray"
                v-model="catType" required item-text="name" item-value="value"> </v-autocomplete>
            </v-col>

            <v-col cols="12" md="1">
              <label class="font-weight-medium body-2">
                Position
              </label>
              <v-text-field type="number" min="0" max="100" placeholder="Enter position"
                v-model.trim="position" maxlength="100"></v-text-field>
            </v-col>

            <v-col cols="12" md="5">
              <v-row class="d-flex">
                <v-col cols="12" md="6" class="pa-0 pl-4">
                  <label class="font-weight-medium body-2">
                    Select Class
                    <span class="requir error--text">*</span>
                  </label>
                </v-col>
                <v-col cols="12" md="6" class="pa-0 align-start">
                  <v-checkbox class="ma-0 pa-0" label="Select All" v-model="classSelectAll"
                    @change="selectAllToggle"></v-checkbox>
                </v-col>
              </v-row>

              <v-autocomplete class="ma-0 pa-0" @change="classChange" multiple return-object
                label="Class" clearable v-model="classIds" :items="classList" key="id"
                item-value="id" item-text="name" small-chips deletable-chips>
              </v-autocomplete>
            </v-col>
            <!-- <a @click="test">test</a> -->
            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Name
                <span class="requir error--text">*</span>
              </label>
              <v-text-field counter="100" required v-model.trim="name" placeholder="Category Name"
                maxlength="100"></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <label class="font-weight-medium body-2">
                Remark
              </label>
              <v-text-field counter="100" placeholder="Category Remark" v-model.trim="remark"
                maxlength="100"></v-text-field>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Description
              </label>
              <v-textarea counter="100" rows="1" placeholder="Category Description"
                v-model.trim="desc" maxlength="100"></v-textarea>
            </v-col>

            <v-col cols="12" md="12">
              <label class="font-weight-medium body-2">
                Parameter's
              </label>
              <v-checkbox class="float-right ma-0 pa-0" label="Show Detailed view"
                v-model="showParam"></v-checkbox>
              <div v-for="(n, i) of prmtr" :key="i">
                <v-card-component>
                  <v-row>
                    <v-col cols="12" md="11" class="pt-0 pb-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <v-text-field title="Position" class="my-0 py-1" min="0" type="number"
                            placeholder="Position" v-model.trim="prmtr[i].position" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="10">
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Parameter name"
                            :required="i === 0" v-model.trim="prmtr[i].name" maxlength="100">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" v-if="showParam">
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Remark"
                            v-model.trim="prmtr[i].remark" maxlength="100"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6" v-if="showParam">
                          <v-text-field class="my-0 py-1" counter="100" placeholder="Description"
                            v-model.trim="prmtr[i].description" maxlength="100"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="1"
                      class="d-flex pt-0 pb-0 flex-column justify-center align-center">
                      <label class="font-weight-medium body-2">No. {{ i + 1 }}</label>

                      <v-card-actions>
                        <v-btn title="Delete parameter" elevation="1" color="error"
                          @click="deleteRow(i, prmtr[i])">
                          <v-icon left> mdi-trash-can </v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                </v-card-component>
              </div>
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" @click="
                    prmtr.push({
                      name: '',
                      remark: '',
                      description: '',
                      position: '',
                      isActive: true
                    })
                  ">
                  <v-icon left> mdi-plus </v-icon>
                  Add Parameter
                </v-btn>
              </v-card-actions>
            </v-col>

            <v-col cols="12">
              <v-card-actions class="d-flex justify-end">
                <v-btn bottom right elevation="1" color="primary" type="submit">
                  <v-icon left> mdi-content-save </v-icon>
                  Save all
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </form>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import CONSTANTS from '@/utils/constants'
// import { mapGetters } from 'vuex'
import _ from 'lodash'
import Utils from '@/utils'

import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['categoryId'],
  data () {
    return {
      name: '',
      remark: '',
      desc: '',
      selectedAcademicYear: '',
      position: 0,
      classList: [],
      classSelectAll: false,
      classIds: [],
      academicYears: [],
      showParam: false,
      prmtr: [
        {
          name: '',
          remark: '',
          description: '',
          position: '',
          isActive: true
        }
      ],
      typeArray: [
        { name: 'ONLINE', value: 'ONLINE' },
        { name: 'OFFLINE', value: 'OFFLINE' }
      ],
      catType: '',
      isEdit: false,
      deleteParameters: []
    }
  },
  created: async function () {
    await this.getClassList()
    await this.getYear()
    if (this.categoryId) {
      this.isEdit = true
      await this.getCategoryDetails()
    }
  },
  watch: {},
  methods: {
    classChange () {
      this.classSelectAll = this.classList.length === this.classIds.length
    },
    selectAllToggle: async function () {
      this.classIds = this.classSelectAll ? this.classList : []
    },
    deleteParameter: async function (parameterId) {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/center-audit/parameter/status/${parameterId}`)
        console.log('Delete parameter response: ', res)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getCategoryDetails: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/center-audit/category/${this.categoryId}`)
        res = res.data[0]
        this.name = res.name
        this.classIds = res.acadAuditCategoryClassMaps.map((a) => {
          return {
            id: a.classID,
            isActive: a.isActive,
            name: a.studentClass.name
          }
        })
        this.prmtr = res.acadAuditParameters
        this.position = res.position
        this.remark = res.remark
        this.catType = res.type
        this.selectedAcademicYear = res.academicYearID
        this.desc = res.description
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    deleteMultipleParameters: async function (arr, isActive = false) {
      try {
        if (arr.length > 0) {
          await http.put(`${CONSTANTS.API_URL}/api/center-audit/parameter/all/status`, {
            parameters: arr,
            isActive: isActive
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    save: async function () {
      try {
        await this.deleteMultipleParameters(this.deleteParameters)
        let idz = _.map(this.classIds, (c) => c.id)
        let final = this.classList.map((a) => {
          return {
            classID: a.id,
            isActive: idz.includes(a.id)
          }
        })

        if (this.isEdit) {
          this.prmtr.map((a) => {
            // delete a.id
            if (!a.id) {
              a.id = ''
            }
            delete a.categoryID
            return a
          })
        }

        let formData = {
          class: final,
          name: this.name,
          remark: this.remark,
          type: this.catType,
          academicYearID: this.selectedAcademicYear,
          description: this.desc,
          position: this.position,
          isActive: true,
          parameter: this.prmtr
        }
        if (this.isEdit) {
          let res = await http.put(`${CONSTANTS.API_URL}/api/center-audit/category/${this.categoryId}`, formData)
          console.log('res', res)
        } else {
          let res = await http.post(`${CONSTANTS.API_URL}/api/center-audit/category`, formData)
          this.okMsg(res.data)
        }

        this.$router.push({ name: 'listAuditCategory' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getClassList: async function () {
      try {
        let data = await http.get(`${CONSTANTS.API_URL}/api/student/class-section?isRequired=true`)
        if (data) {
          this.classList = data.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${CONSTANTS.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`)
        this.academicYears = response.data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.selectedAcademicYear = academicYear.id
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteRow (e, item) {
      if (item.id) {
        this.deleteParameters.push(item.id)
        // this.deleteParameter(item.id)
      }
      if (this.prmtr.length > 1) {
        this.prmtr = _.filter(this.prmtr, (a, b) => b !== e)
      } else {
        this.errMsg('Cannot delete! Atleast one parameter is required!')
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>

<style></style>
